// TODO: should be a MenuList stringMap instead
export const stringMapDefault = {
    emptyListMessage: "No Items Available"
};
